import {changeEvent, dispatchCustomEvent} from "../../../../../webpack/modules/events";
import {hideOffcanvas} from "../../../../../webpack/modules-optimized/offcanvas";
import {trackProductPageGa4Events} from "../../../../../webpack/modules-optimized/product";
import {
    hideOptionErrors,
    renderPreviewImage,
    updatePriceElements,
    updateSizesPrices
} from "../../../../../webpack/modules-optimized/product-page";

changeEvent('#product-page .options[data-option-type="selectable"] input[name="color"]', false, function(element) {
    let container = element.closest('.product-scope');
    let offcanvas = element.closest('.offcanvas');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);

    offcanvas.querySelectorAll('.color.selected').forEach(option => option.classList.remove('selected'));
    element.nextElementSibling.classList.add('selected');
    dispatchCustomEvent(
        'productColorChanged',
        {
            'option': offcanvas,
            'previewElement': previewElement,
            'colorSelected': element.value,
            'orientationElement': container.querySelector(`.options-section .options[data-type="orientation"]`),
            'defaultOrientationElement': container.querySelector(`input[value="normal"]`),
            'glassReversedElement': container.querySelector(`.options-section .options[data-type="glass-reversed"]`)
        }
    );

    if (previewElement && previewElement.classList.contains('d-none')) previewElement.classList.remove('d-none');
    hideOffcanvas(offcanvas.id);
    trackProductPageGa4Events('Color', element.dataset.colorName || '-');
    updatePriceElements(container);
    updateSizesPrices(container);
    setTimeout(() => renderPreviewImage(container), 200);
    hideOptionErrors(offcanvas);
});